import compareDocumentItems from 'builder/Knowledge/components/TreeView/compareDocumentItems';
import { 
  regexFindDigits, 
  underScoreSeparator, 
  competencyDocumentItemPrefixes,
} from 'constants/knowledgeMap';

/**
 * Calculate prefix number for duplicated knowledge map items for ordering
 * 
 * @param {Object} competencyTree
 * @param {Object} competencyItem
 * @param {Array} parentItems
 * @returns {Number} response of calculated prefix number
 */
export const calculatePrefixNumber = ( competencyTree, competencyItem ) => {
  const parentItems = competencyTree.getRootItems().sort(compareDocumentItems);
  const itemIndex = parentItems.findIndex((item) => item.id === competencyItem.id);
  const { id : competencyItemId } = competencyItem;
  if(itemIndex > -1) {
    const currentItemPrefix = processPrefix(competencyItem, true);
    return getPrefixNumber(itemIndex, parentItems, currentItemPrefix, true);
  }

  const [ parentItemId ]= competencyTree.getAllParentsByDeepChildId(competencyItemId);
  const parentChildItems = competencyTree.getChildren(parentItemId).sort(compareDocumentItems);
  const childItemIndex = parentChildItems.findIndex((item) => item.id === competencyItemId);
  const currentchildItemPrefix = processPrefix(competencyItem);
  return getPrefixNumber(childItemIndex, parentChildItems, currentchildItemPrefix);
};

/**
 * Get the prefix number for duplicated knowledge map items for ordering
 * 
 * @param {Number} itemIndex
 * @param {Array} itemList
 * @param {String} currentItemPrefix
 * @param {Boolean} isParent
 * @returns {Number} response of prefix number
 */
export const getPrefixNumber = (itemIndex, itemList, currentItemPrefix, isParent) => {
  if(itemIndex > 0) {
    const itemBeforeCurrentItem = itemList[itemIndex-1];
    const itemBeforeCurrentItemPrefix = processPrefix(itemBeforeCurrentItem, isParent);
    return calculateMedian(itemBeforeCurrentItemPrefix , currentItemPrefix);
  } 
  return calculateMedian(0 , currentItemPrefix);
};

/**
 * Process the prefix value of parent and child.
 * 
 * @param {Object} competencyItem
 * @param {Boolean} parent
 * @returns {Number} response of decimal number of prefix number
 */
export const processPrefix = (competencyItem, parent) => {
  const {
    titleKey,
  } = competencyItem;
  const [ parentPrefixString, childPrefixString ] =  titleKey.split(underScoreSeparator);
  
  if(parent) {
    return getDecimalValue(parentPrefixString);
  }

  return getDecimalValue(childPrefixString);
};

/**
 * get Decimal value from title prefix String.
 * 
 * @param {String} titleKey
 * @returns {Number} response of decimal number of prefix number
 */
export const getDecimalValueFromTitlePrefix = (titleKey) => {
  const {
    COMPETENCY_DOCUMENT_ITEM_CHILD_KEY,
  } = competencyDocumentItemPrefixes;

  if(!titleKey.includes(COMPETENCY_DOCUMENT_ITEM_CHILD_KEY)) {
    return processPrefix({ titleKey }, true);
  }

  return processPrefix({ titleKey });
};

/**
 * Get the decimal value from given string
 * 
 * @param {String} inputString
 * @param {Boolean} parent
 * @returns {Number} response of decimal number of prefix number
 */
export const getDecimalValue = (inputString) => {
  if(!inputString) return 0;
  
  const prefix = inputString.match(regexFindDigits);
  let prefixString = prefix && prefix.length ? prefix[0] : '0';
  if(prefix && prefix[1]) {
    prefixString = `${prefixString}.${prefix[1]}`;
  }

  return parseFloat(prefixString);
};

/**
 * Calculate the median for minimum and maximum value
 * 
 * @param {Number} minimumValue
 * @param {Number} maximumValue
 * @returns {Number} response of median value
 */
export const calculateMedian = (minimumValue, maximumValue) => {
  const result = (maximumValue - minimumValue) / 2;
  const newPrefixValue =  minimumValue + result;
  
  return newPrefixValue;
};